/* global globalThis:readonly */
const amountText = (value, signed = false) =>
  typeof value === 'string' &&
  (signed ? /^-?\d+(?:\.\d+|\/[1-9]\d*)?$/ : /^\d+(?:\.\d+|\/[1-9]\d*)?$/).test(
    value
  )
    ? value
    : null;

export const customerMoneyV1014 = (log) => {
  const money = log?.money;
  if (!money || money.currency !== 'USD') return null;
  return {
    currency: 'USD',
    priced_usd: amountText(money.priced_usd),
    wallet_debit_quota:
      typeof money.wallet_debit_quota === 'string' &&
      /^\d+$/.test(money.wallet_debit_quota)
        ? money.wallet_debit_quota
        : null,
    wallet_debit_usd: amountText(money.wallet_debit_usd),
    rounding_delta_usd: amountText(money.rounding_delta_usd, true),
    state:
      typeof money.state === 'string' && /^[a-z_]+$/.test(money.state)
        ? money.state
        : 'unavailable',
    ...(['frozen_quota_rate', 'current_config_unfrozen'].includes(
      money.wallet_conversion_basis
    )
      ? { wallet_conversion_basis: money.wallet_conversion_basis }
      : {}),
  };
};

export const customerMoneyFieldsV1014 = [
  ['currency', '币种', 'Currency'],
  ['priced_usd', '计价金额 USD', 'Priced USD'],
  ['wallet_debit_quota', '钱包实扣 quota', 'Wallet debit quota'],
  ['wallet_debit_usd', '钱包实扣 USD', 'Wallet debit USD'],
  ['rounding_delta_usd', '舍入差额 USD', 'Rounding delta USD'],
  ['state', '金额状态', 'Money state'],
  ['wallet_conversion_basis', '钱包换算依据', 'Wallet conversion basis'],
];

export const customerMoneyTextV1014 = (log) => {
  const money = customerMoneyV1014(log);
  return customerMoneyFieldsV1014
    .map(([field, , label]) => `${label}: ${money?.[field] ?? '-'}`)
    .join(' | ');
};

// Compare exact rational strings, including integer values beyond JS's safe
// range. This is display ordering only, never a customer charging calculation.
export const compareCustomerMoneyV1014 = (left, right) => {
  const fraction = (log) => {
    const money = customerMoneyV1014(log);
    const value =
      money?.wallet_debit_usd ??
      money?.priced_usd ??
      amountText(log?.customer_charge_usd) ??
      amountText(log?.legacy_amount_usd);
    if (value == null) return null;
    if (value.includes('/')) return value.split('/').map(globalThis.BigInt);
    const [whole, decimals = ''] = value.split('.');
    return [
      globalThis.BigInt(whole + decimals),
      globalThis.BigInt(10) ** globalThis.BigInt(decimals.length),
    ];
  };
  const a = fraction(left);
  const b = fraction(right);
  if (!a || !b) return a ? -1 : b ? 1 : 0;
  const difference = a[0] * b[1] - b[0] * a[1];
  return difference === globalThis.BigInt(0)
    ? 0
    : difference > globalThis.BigInt(0)
    ? -1
    : 1;
};
